import { gql } from '@apollo/client';

import { lessonWorksheetFragment } from './sections/lesson-worksheets/lesson-worksheets.graphql';
import { lessonPrintablesFragment } from './sections/lesson-printables/lesson-printables.graphql';
import {
  lessonLandscapeImageFragment,
  lessonSquareImageFragment,
} from './sections/images/hero-image.graphql';
import { lessonVocabularyFragment } from './sections/vocabulary/vocabulary.graphql';
import { lessonOutcomesFragment } from './sections/outcomes/outcomes.graphql';
import { lessonTeachingLearningSequenceFragment } from './sections/teaching-learning-sequence/teaching-learning-sequence.graphql';
import { lessonTextualConceptsFragment } from './sections/textual-concepts/textual-concepts.graphql';
import { lessonBigIdeasFragment } from './sections/big-ideas/big-ideas.graphql';
import { materialsFragment } from 'approot/shared/graphql/lesson/lesson.graphql';
import { SubjectFragment } from 'approot/shared/graphql/startup-data/startup-data.graphql';
import {
  lessonIntegratedUnitFragment,
  lessonUnitFragment,
} from './sections/details/details.graphql';
import { lessonEnglishContentAreaFragment } from './sections/content-areas/content-areas.graphql';
import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';

export const GET_GUEST_LESSON_DETAILS = gql`
  query GetGuestLessonById($input: GetLessonByIdInput!) {
    getLessonById(input: $input) {
      id
      authorId
      name
      slug
      notesJson
      focusQuestion {
        value
      }
      phenomena {
        value
      }
      subjects {
        ...SubjectFragment
      }
      years {
        id
        name
        label
      }
      lessonActivitiesSummary {
        coreActivities
        deeperActivities
        challengingActivities
        stimulus
      }
      lessonActivities {
        id
        language
        status
        version
      }
      stimulusResources {
        ...StimulusResource
      }
      archivedAt
      ...LessonUnitFragment
      ...LessonIntegratedUnitFragment
      ...LessonEnglishContentAreaFragment
      ...LessonWorksheetFragment
      ...LessonLandscapeImageFragment
      ...LessonSquareImageFragment
      ...LessonVocabularyFragment
      ...LessonOutcomesFragment
      ...LessonPrintablesFragment
      ...LessonTeachingLearningSequenceFragment
      ...LessonTextualConceptsFragment
      ...LessonBigIdeasFragment
    }
  }
  ${lessonUnitFragment}
  ${lessonIntegratedUnitFragment}
  ${lessonWorksheetFragment}
  ${lessonPrintablesFragment}
  ${lessonLandscapeImageFragment}
  ${lessonSquareImageFragment}
  ${lessonVocabularyFragment}
  ${lessonOutcomesFragment}
  ${lessonTeachingLearningSequenceFragment}
  ${lessonTextualConceptsFragment}
  ${lessonEnglishContentAreaFragment}
  ${lessonBigIdeasFragment}
  ${materialsFragment}
  ${SubjectFragment}
  ${stimulusResourceFragment}
`;
